module.exports = __webpack_public_path__ + "static/media/csp.e544b71f.png";